import React, { Component } from 'react';
import axios from 'axios';
import '../../assets/css/Register.css';
import { connect } from 'react-redux';
import Button from '../Button';
import {changeCurrentUser} from '../../state/actionCreators/index'
import withRouter from '../../utility/withRouter';
import apiInstance from '../apiInstance';
import { GoogleLogin } from '@react-oauth/google';

class Register extends Component {
    constructor() {
        super();
        this.state = {
            email: '',
            password: '',
            view: 'select',
            loading: false,
            error: '',
            fieldErrors: {},
            forgotPwdPp: React.createRef(),
        };
    }

    handleSignIn = (e) => {
        e.preventDefault();

        this.setState({ fieldErrors: {}, error: "", loading: true })

        var request_body = { email: this.state.email, password: this.state.password };

        axios.post(process.env.REACT_APP_SERVER_URL + `/user/login`, request_body)
            .then(async (response) => {
                localStorage.setItem('token', response.data.user.token);
                localStorage.setItem('userId', response.data.user.id);
                this.props.changeCurrentUser(response.data.user)

                const sid = new URLSearchParams(this.props.location.search).get('sid');
                if (sid) {
                    try {
                        await apiInstance.put('/dashboard/claim', {
                            userId: response.data.user.id,
                            siteId: sid
                        });
                    } catch (err) {
                        console.error('Claim failed:', err.message);
                    }
                    window.location.href = '/websites';
                } else {
                    const redirect = new URLSearchParams(this.props.location.search).get('redirect');
                    window.location.href = redirect ? decodeURIComponent(redirect) : "/websites";
                }
            })
            .catch((error) => {
                console.log(error)
                if (error.response) {
                    if (error.response.status == 400 && error.response.data.fieldErrors) {
                        this.setState({ fieldErrors: error.response.data.fieldErrors, loading: false })
                    } else {
                        this.setState({ error: error.response.data?.message || 'Something went wrong, please try again later', loading: false })
                    }
                } else {
                    this.setState({ loading: false })
                }
            });
    }

    handleForgetPass = (e) => {
        this.state.forgotPwdPp.current.openPopup()
    }

    handleInputChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        this.setState((prevState) => {
            return ({
                ...prevState,
                [name]: value
            })
        })
    }

    handleGoogleSuccess = (googleResponse) => {

        this.setState({ loading: true, error: '' });

        axios.post(process.env.REACT_APP_SERVER_URL + `/user/google-auth`, {
            idToken: googleResponse.credential
        })
            .then(async (response) => {
                localStorage.setItem('token', response.data.user.token);
                localStorage.setItem('userId', response.data.user.id);
                this.props.changeCurrentUser(response.data.user)

                const sid = new URLSearchParams(this.props.location.search).get('sid');
                if (sid) {
                    try {
                        await apiInstance.put('/dashboard/claim', {
                            userId: response.data.user.id,
                            siteId: sid
                        });
                    } catch (err) {
                        console.error('Claim failed:', err.message);
                    }
                    window.location.href = '/websites';
                } else {
                    const redirect = new URLSearchParams(this.props.location.search).get('redirect');
                    window.location.href = redirect ? decodeURIComponent(redirect) : "/websites";
                }
            })
            .catch((error) => {
                console.log(error)
                this.setState({ error: error.response?.data?.message || 'Google sign-in failed. Please try again.', loading: false })
            });
    }

    handleGoogleError = () => {
        this.setState({ error: 'Google sign-in failed. Please try again.', loading: false });
    }

    render() {
        let { view, email, password, loading, error, fieldErrors } = this.state;
        return (
            <div className="mjs-register-wrapper">
                <div className={`mjs-rg-container`} id="mjs-rg-container">
                    <div className={`mjs-rg-form-container mjs-rg-sign-in-container`}>

                        <form action="#">
                            <h1>Sign In</h1>

                            {view === 'select' &&
                                <>
                                    <GoogleLogin onSuccess={this.handleGoogleSuccess} onError={this.handleGoogleError} text="signin_with"/>
                                    <div className="mjs-or-divider"><span>OR</span></div>
                                    <button type="button" disabled={loading} onClick={() => this.setState({view: 'email', error: '', fieldErrors: {}})}>Continue with Email</button>
                                </>
                            }

                            {view === 'email' &&
                                <>
                                    <div className='mjs-back-btn'>
                                        <button type="button" disabled={loading} onClick={() => this.setState({view: 'select', error: '', fieldErrors: {}})}><i className="fa-solid fa-arrow-left"></i></button>
                                    </div>

                                    <div className='mjs-register-emailadrs'><i className="fa-solid fa-envelope"></i><input
                                        type="email"
                                        placeholder="Email Address"
                                        name="email"
                                        value={email}
                                        onChange={this.handleInputChange}
                                    /></div>
                                    {fieldErrors.email && <span className="mjs-error">{fieldErrors.email}</span>}

                                    <div className='mjs-register-passwrd'><i className="fa-solid fa-lock"></i><input
                                        type="password"
                                        placeholder="Password"
                                        name="password"
                                        value={password}
                                        onChange={this.handleInputChange}
                                    /></div>
                                    {fieldErrors.password && <span className="mjs-error">{fieldErrors.password}</span>}

                                    <button
                                        onClick={this.handleSignIn}
                                        disabled={!email || !password || loading}
                                    >
                                        {loading ? <i className="fa-solid fa-spinner fa-spin"></i> : 'Sign In'}
                                    </button>

                                    <div className="mjs-frgt-pswrd" onClick={this.handleForgetPass}>Forgot password</div>
                                </>
                            }
                            {loading && view === 'select' && <i className="fa-solid fa-spinner fa-spin"></i>}
                            <span className="mjs-error">{error}</span>

                        </form>

                    </div>
                    <div className="mjs-rg-overlay-container">
                        <div className="mjs-rg-overlay">
                            <div className={`mjs-rg-overlay-panel mjs-rg-overlay-right`}>
                                <h1>Welcome Back!</h1>
                                <p>Manage your website, domain, email, backups, and billing — all in one place.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <ForgotPasswordPopup ref={this.state.forgotPwdPp}/>
            </div>
        );
    }
}

class ForgotPasswordPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            displayPopup: false,
            error: '',
            msg: "",
            fieldErrors: {}
        };
    }

    resetFields = () => {
        this.setState((prevState) => {
            return ({
                email: '',
                displayPopup: false,
                error: '',
                msg: "",
                fieldErrors: {}
            })
        })
    }

    handleInputChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        this.setState((prevState) => {
            return ({
                ...prevState,
                [name]: value
            })
        })
    }

    openPopup = () => {
        this.setState((prevState) => {
            return ({
                ...prevState,
                displayPopup: true,
            })
        })
    }

    closePopup = () => {
        this.resetFields();
        this.setState((prevState) => {
            return ({
                displayPopup: false,
            })
        })
    }

    updateErrorMessage = (error = "", msg = "") => {
        this.setState((prevState) => {
            return ({
                ...prevState,
                error: error,
                msg: msg
            })
        })
    }

    sendMail = () => {

        this.setState((prevState) => {
            return ({
                ...prevState,
                error: "",
                msg: "",
                fieldErrors: {}
            })
        })
       
        const requestBody = {email: this.state.email}
        axios.post(process.env.REACT_APP_SERVER_URL + `/user/resetPassword`, requestBody)
            .then(response => {
                this.updateErrorMessage("", "Email sent successfully!")
            })
            .catch(error => {
                console.error('Error sending email:', error);
                if (error.response) {
                    if (error.response.status == 400 && error.response.data.fieldErrors) {

                        this.setState((prevState) => {
                            return ({
                                ...prevState,
                                fieldErrors: error.response.data.fieldErrors
                            })
                        })
                    }
                    else {

                        this.setState((prevState) => {
                            return ({
                                ...prevState,
                                error: error.response.data
                            })
                        })
                    }
                }
            });
    }

    render () {

        let {displayPopup, error, fieldErrors, email, msg} = this.state;
        return (
            <div className={'mjs-popup mjs-forgot-pwd-pp' + (displayPopup ? '' : ' mjs-hidden')}>
                <div className="mjs-forgotpwd">
                    <h2>Forgot Password</h2>
                    <span className="mjs-popup-close" onClick={this.closePopup}>
                        <i className="fa-solid fa-xmark"></i>
                    </span>
                    <div className="mjs-row">
                        <div className="mjs-col100">
                            <input
                                type="test"
                                placeholder="Enter Email Address"
                                name="email"
                                value={email}
                                onChange={this.handleInputChange}
                            />
                            {fieldErrors.email && <span className="mjs-error">{fieldErrors.email}</span>}
                        </div>
                    </div>
                    <div className="mjs-row">
                        <div className="">
                            <Button name="Send mail" eventHandler={() => {this.sendMail()}} />
                        </div>
                        <div className="">
                            <Button name="Cancel" eventHandler={() => {this.closePopup()}} />
                        </div>
                    </div>
                    <div className={'mjs-error' + (error ? '' : ' mjs-hidden')}>{error}</div>
                    <div className={'mjs-msg' + (msg ? '' : ' mjs-hidden')}>{msg}</div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return (
        {
            user: state.currentUser,
        }
    )
}
const mapDispatchToProps = (dispatch) => {
    return (
      {
        changeCurrentUser: (user) => { dispatch(changeCurrentUser(user)) },
      }
    )
  }
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Register));